"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var editor_web_1 = require("@21st-night/editor-web");
var RichText = function (props) {
    return (react_1.default.createElement(editor_web_1.RichText, __assign({ imageUrl: process.env.REACT_APP_IMGIX_URL }, props)));
};
exports.default = RichText;
//# sourceMappingURL=RichText.js.map